import React from "react";
import { Icon } from "@iconify/react";
import { Link, useNavigate } from "react-router-dom";

const SidebarItem = ({
  item,
  isHovered,
  isActive,
  onHover,
  onClick,
  userRoles,
  notificationCount,
}) => {
  const navigate = useNavigate();

  const handleClick = (e) => {
    if (onClick) {
      onClick();
    }
    if (item.name === "Teams") {
      e.preventDefault(); // Prevent default `<Link>` behavior
      if (
        userRoles.includes("ROLE_MANAGER") ||
        userRoles.includes("ROLE_ADMIN")
      ) {
        navigate("/team/mark-attendance");
      } else if (userRoles.includes("ROLE_HR")) {
        navigate("/team/comp-payroll");
      } else {
        navigate("/team"); // Default fallback route
      }
    }
  };

  // Filter submenu items based on user roles
  const filteredSubmenu = item.submenu
    ? item.submenu.filter((subItem) =>
        subItem.roles.some((role) => userRoles.includes(role)),
      )
    : [];

  return (
    <li
      className={`sidebar-singleitem ${isActive ? "active" : ""}`}
      onMouseEnter={() => onHover(item.name)}
      onMouseLeave={() => onHover(null)}
    >
      <Link
        to={item.to}
        className="item-container item-content"
        onClick={handleClick}
      >
        <Icon icon={item.icon} className="icon" />
        <span className="item-name">{item.name}</span>
        {notificationCount > 0 && (
          <span className="badge">{notificationCount}</span>
        )}
      </Link>
      {/* Render submenu if it exists and has items after filtering */}
      {filteredSubmenu.length > 0 && (
        <ul className="submenu">
          {filteredSubmenu.map((subItem) => {
            // Filter nested submenu items by user roles
            const filteredNestedItems = subItem.submenu
              ? subItem.submenu.filter((nestedItem) =>
                  nestedItem.roles.some((role) => userRoles.includes(role)),
                )
              : [];
            return (
              <li key={subItem.name} className="submenu-item">
                <Link to={subItem.to} className="submenu-item-content">
                  <span className="item-name">{subItem.name}</span>
                </Link>
                {/* Render nested submenu if it exists and has items after filtering */}
                {filteredNestedItems.length > 0 && (
                  <ul className="subsubmenu">
                    {filteredNestedItems.map((nestedItem) => (
                      <li key={nestedItem.name} className="subsubmenu-item">
                        <Link to={nestedItem.to}>
                          <span className="item-name">{nestedItem.name}</span>
                        </Link>
                      </li>
                    ))}
                  </ul>
                )}
              </li>
            );
          })}
        </ul>
      )}
    </li>
  );
};

export default SidebarItem;
